import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState } from "react";
import cx from "classnames";
var css = {
  "collapsible": "rui-mCYoN",
  "title": "rui-hAEue",
  "content": "rui-rPi5B",
  "collapsed": "rui-Mk2EC",
  "collapsedContent": "rui-Damqk"
};
import Icon from "../Icon/Icon";
var Collapsible = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var title = _ref.title,
    titleClassName = _ref.titleClassName,
    isInitiallyOpen = _ref.isInitiallyOpen,
    children = _ref.children,
    collapsedContent = _ref.collapsedContent,
    collapsedContentClassName = _ref.collapsedContentClassName,
    _ref$collapsedTitleCl = _ref.collapsedTitleClassName,
    collapsedTitleClassName = _ref$collapsedTitleCl === void 0 ? "" : _ref$collapsedTitleCl,
    className = _ref.className,
    onClick = _ref.onClick,
    _ref$arrowSize = _ref.arrowSize,
    arrowSize = _ref$arrowSize === void 0 ? 16 : _ref$arrowSize,
    contentClassName = _ref.contentClassName,
    _ref$dataAutId = _ref["data-aut-id"],
    dataAutId = _ref$dataAutId === void 0 ? "collapsible" : _ref$dataAutId;
  var _useState = useState(function () {
      return !!isInitiallyOpen;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    isContentOpen = _useState2[0],
    setContentState = _useState2[1];
  var toggleContent = useCallback(function () {
    setContentState(!isContentOpen);
    onClick && onClick(!isContentOpen);
  }, [isContentOpen, onClick]);
  return /*#__PURE__*/React.createElement("div", {
    "data-aut-id": dataAutId,
    className: cx(css.collapsible, className),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    "data-aut-id": "collapsibleAction",
    className: cx(css.title, titleClassName, _defineProperty({}, collapsedTitleClassName, !isContentOpen)),
    onClick: toggleContent,
    onKeyPress: toggleContent,
    tabIndex: 0,
    role: "button"
  }, /*#__PURE__*/React.createElement("span", null, title), /*#__PURE__*/React.createElement(Icon, {
    icon: isContentOpen ? "arrowUp" : "arrowDown",
    size: arrowSize
  })), isContentOpen && /*#__PURE__*/React.createElement("div", {
    className: cx(css.content, contentClassName, _defineProperty({}, css.collapsed, !isContentOpen))
  }, children), !isContentOpen && collapsedContent && /*#__PURE__*/React.createElement("div", {
    className: cx(css.collapsedContent, collapsedContentClassName)
  }, collapsedContent));
});
Collapsible.displayName = "Collapsible";
export default Collapsible;